import { environment } from '../../../environments/environment';
import type { ScotsmanMockTimingConfig } from '../../../environments/environment.model';

/** sessionStorage JSON overrides `environment.mockApiTiming.scotsman` (devtools only). */
export const SCOTSMAN_MOCK_TIMING_STORAGE_KEY = 'momentum.mock.scotsman.timing';

export interface ResolvedScotsmanMockTiming {
  initialLoadDelayMs: number;
  pollResponseDelayMs: number;
  analyzerReadyAfterGetPolls: number;
  replayAnalyzerOnEachLoad: boolean;
}

const DEFAULTS: ResolvedScotsmanMockTiming = {
  initialLoadDelayMs: 1600,
  pollResponseDelayMs: 500,
  analyzerReadyAfterGetPolls: 4,
  replayAnalyzerOnEachLoad: true,
};

function coerceTiming(
  partial: ScotsmanMockTimingConfig | null | undefined,
): ResolvedScotsmanMockTiming {
  const initialLoadDelayMs =
    typeof partial?.initialLoadDelayMs === 'number' && partial.initialLoadDelayMs >= 0
      ? partial.initialLoadDelayMs
      : DEFAULTS.initialLoadDelayMs;
  const pollResponseDelayMs =
    typeof partial?.pollResponseDelayMs === 'number' && partial.pollResponseDelayMs >= 0
      ? partial.pollResponseDelayMs
      : DEFAULTS.pollResponseDelayMs;
  const analyzerReadyAfterGetPolls =
    typeof partial?.analyzerReadyAfterGetPolls === 'number' &&
    partial.analyzerReadyAfterGetPolls >= 1
      ? Math.floor(partial.analyzerReadyAfterGetPolls)
      : DEFAULTS.analyzerReadyAfterGetPolls;
  const replayAnalyzerOnEachLoad =
    typeof partial?.replayAnalyzerOnEachLoad === 'boolean'
      ? partial.replayAnalyzerOnEachLoad
      : DEFAULTS.replayAnalyzerOnEachLoad;

  return {
    initialLoadDelayMs,
    pollResponseDelayMs,
    analyzerReadyAfterGetPolls,
    replayAnalyzerOnEachLoad,
  };
}

function readSessionOverride(): ScotsmanMockTimingConfig | null {
  try {
    const raw = globalThis.sessionStorage?.getItem(SCOTSMAN_MOCK_TIMING_STORAGE_KEY);
    if (!raw?.trim()) {
      return null;
    }
    return JSON.parse(raw) as ScotsmanMockTimingConfig;
  } catch {
    return null;
  }
}

/** Effective SCOTSMAN mock timing: defaults ← environment ← sessionStorage. */
export function getScotsmanMockTiming(): ResolvedScotsmanMockTiming {
  return coerceTiming({
    ...DEFAULTS,
    ...environment.mockApiTiming?.scotsman,
    ...readSessionOverride(),
  });
}
